import React, { useEffect, useState } from 'react';
import { Box, Button, Typography, Accordion, AccordionSummary, AccordionDetails, Chip, IconButton, TableCell, TableBody, TableRow, TableHead, Table, CircularProgress } from '@mui/material';
import { ExpandMoreOutlined, MoreVert } from '@mui/icons-material';
import { api } from '../../../services/api';
import CreateCajaModal from "../../modales/caja/CreateCajaModal";

const CajaTab = ({ eventoId, vendedores, allTarifas, allCajas,
  loadingCajas,
  refetchCajas, isMobile, onSuccess, onError }) => {

  const [openCreateCajaModal, setOpenCreateCajaModal] = useState(false);
  const [loadingCreateCaja, setLoadingCreateCaja] = useState(false);

  const handleCrearCaja = async (data) => {
    setLoadingCreateCaja(true);
    const res = await api.caja.createCaja(eventoId, {
      caja: data.nombre,
      idusuario: data.idusuario,
      tarifas: data.tarifas
    });
    setLoadingCreateCaja(false);

    if (res.status === "success") {
      setOpenCreateCajaModal(false);
      onSuccess("Caja creada correctamente");
      refetchCajas();
    } else {
      onError(res.message || "Error al crear caja");
    }
  };

  const cajasPorUsuario = Array.isArray(allCajas) && allCajas?.length > 0
    ? allCajas.reduce((acc, caja) => {
      if (!acc[caja.usuario]) {
        acc[caja.usuario] = {
          cajas: [],
          nombre_completo: caja.nombre_completo,
          usuario: caja.usuario
        };
      }
      acc[caja.usuario].cajas.push(caja);
      return acc;
    }, {})
    : {};

    if (loadingCajas) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', py: 4 }}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box>
      <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", mb: 2 }}>
        <Typography
          variant="h6"
          sx={{
            fontSize: "18px",
            fontWeight: "600",
            color: "#5656ff",
          }}
        >
          Cajas del Evento ({allCajas?.length || 0})
        </Typography>

        <Button
          variant="outlined"
          sx={{
            marginLeft: "0 !important",
            backgroundColor: "#5656FF",
            color: "white",
            padding: "5px 10px",
            borderRadius: "4px",
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: window.innerWidth <= 576 ? "13px" : "14px",
          }}
          onClick={() => setOpenCreateCajaModal(true)}
        >
          Crear Caja
        </Button>
      </Box>
      <Box sx={{ mb: 4 }}>
        {Object.keys(cajasPorUsuario)?.length === 0 ? (
          <Box sx={{
            textAlign: 'center',
            py: 4,
            border: '1px dashed #ccc',
            borderRadius: 2,
            backgroundColor: '#f9f9f9'
          }}>
            <Typography color="text.secondary">
              No hay cajas creadas para este evento
            </Typography>
          </Box>
        ) : (
          Object.entries(cajasPorUsuario).map(([usuario, data]) => (
            <>
              <Accordion key={usuario} sx={{ boxShadow: 1, /* mb: 1  */ }}>
                <AccordionSummary expandIcon={<ExpandMoreOutlined />}>
                  <Box sx={{
                    display: "flex",
                    flexDirection: isMobile ? "column" : "row",
                    width: "100%",
                    justifyContent: "space-between",
                    alignItems: isMobile ? "flex-start" : "center"
                  }}>
                    <Box sx={{ flex: 1 }}>
                      <Typography sx={{
                        fontSize: "16px",
                        fontWeight: 600,
                        color: "#0b0062"
                      }}>
                        {data.nombre_completo}
                      </Typography>
                      <Typography sx={{
                        fontSize: "14px",
                        color: "#666",
                        mt: 0.5
                      }}>
                        {data?.usuario}
                      </Typography>
                    </Box>

                    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                      <Chip
                        label={`${data.cajas[0].caja}`}
                        size="small"
                        sx={{
                          backgroundColor: "#e3f2fd",
                          color: "#1976d2",
                          fontWeight: 500
                        }}
                      />
                      <IconButton size="small" onClick={(e) => e.stopPropagation()}>
                        <MoreVert fontSize="small" />
                      </IconButton>
                    </Box>
                  </Box>
                </AccordionSummary>

                <AccordionDetails>
                  {data.cajas.map((caja) => (
                    <Box key={caja.id}>
                      <Table size="small">
                        <TableHead>
                          <TableRow>
                            <TableCell>Concepto</TableCell>
                            <TableCell>Precio</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {caja?.tarifas?.map((tarifa) => (
                            <TableRow key={tarifa.id}>
                              <TableCell sx={{ display: "flex", alignItems: "center" }}>
                                <span style={{
                                  display: "inline-block",
                                  width: 18,
                                  height: 10,
                                  borderRadius: 4,
                                  background: (() => {
                                    try {
                                      const c = JSON.parse(tarifa.color);
                                      return `rgba(${c.r},${c.g},${c.b},${c.a})`;
                                    } catch { return "#eee"; }
                                  })(),
                                  marginRight: 8
                                }} />
                                {tarifa.concepto}
                              </TableCell>
                              <TableCell>
                                ${tarifa.precio.toLocaleString('es-AR')}
                              </TableCell>
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                    </Box>
                  ))}
                </AccordionDetails>
              </Accordion>

            </>
          ))
        )}
      </Box>

      <CreateCajaModal
        open={openCreateCajaModal}
        onClose={() => setOpenCreateCajaModal(false)}
        onCrear={handleCrearCaja}
        vendedores={vendedores}
        allTarifas={allTarifas}
        loading={loadingCreateCaja}
      />
    </Box>
  );
};

export default CajaTab;